import { camelCase } from 'lodash-es';

import { EXTENDED_UTM_KEYS } from '@pflegia/types/common/constants/utm-keys';
import { cookieStorage } from '@pflegia/ui/storage/cookie-storage';

import { INITIAL_PREFIX, INITIAL_UTM_TIMESTAMP, LATEST_UTM_TIMESTAMP, UTM_KEYS } from '../constants/utm-keys';

interface CollectUtmDataOptions {
  withInitial?: boolean;
}

export const collectUtmData = ({ withInitial = true }: CollectUtmDataOptions = {}) => {
  const initialTimestamp = withInitial ? cookieStorage.getItem(INITIAL_UTM_TIMESTAMP) : null;
  const latestTimestamp = withInitial ? cookieStorage.getItem(LATEST_UTM_TIMESTAMP) : null;

  // Create a set of valid keys from EXTENDED_UTM_KEYS for validation
  const validKeys = new Set<string>(EXTENDED_UTM_KEYS as unknown as string[]);

  const utmData: Record<string, string | Date | undefined | null> = UTM_KEYS.reduce<Record<string, string | Date | undefined | null>>(
    (acc, utmKey) => {
      const camelKey = camelCase(utmKey);
      const initialCamelKey = camelCase(INITIAL_PREFIX + utmKey);

      return {
        ...acc,
        ...(validKeys.has(camelKey) && { [camelKey]: cookieStorage.getItem(utmKey) }),
        ...(withInitial && validKeys.has(initialCamelKey) && { [initialCamelKey]: cookieStorage.getItem(INITIAL_PREFIX + utmKey) }),
      };
    },
    withInitial
      ? {
          ...(latestTimestamp && { updatedAt: new Date(Number(latestTimestamp)) }),
          ...(initialTimestamp && { createdAt: new Date(Number(initialTimestamp)) }),
        }
      : {},
  );

  return utmData;
};
